module.exports = __webpack_public_path__ + "img/staking-popup-banner.3d27c167.png";